// extracted by mini-css-extract-plugin
module.exports = {"alert-orange":"#bf8a3e","alert-orange-interaction":"#986e31","alert-orange-disabled":"#f2e8d9","alertButton":"AlertButton_alertButton__2r-Xr"};